import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import ActiveBotContainer from "../../components/ActiveBotContainer/ActiveBotContainer";
import { useSelector } from "react-redux";

const ActiveTgBotScreen = () => {
  const { activeBot } = useSelector((state) => state?.integration);

  return (
    <ScreenLayout>
      <ActiveBotContainer data={activeBot} />
    </ScreenLayout>
  );
};

export default ActiveTgBotScreen;
